import React, { useState, useEffect, useRef } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { useParams } from 'react-router';
import { Link, useNavigate } from 'react-router-dom';
import Scroller from 'ui-component/Scroller';
// import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import DeleteConfirmationGlass from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmationGlass';
import { useDispatch } from 'react-redux';
import { setLoading } from 'store/reducers/mainSlice';
import { FaSpinner, FaPlus, FaSave, FaTimes, FaTimesCircle } from 'react-icons/fa';
import { allCountriesList } from 'assets/helperdata/countries-list';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { FaCircleCheck } from 'react-icons/fa6';
import { ImSpinner2 } from 'react-icons/im';
import Select from 'react-select';
import FileUpload from 'ui-component/FileUpload';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { CloseIcon, QuestionMarkCircleIcon } from 'ui-component/custom-icons/icons';
import './contactsforms.scss';
import toast from 'react-hot-toast';
import useIsMobile from 'utils/isMobileUtils';
import { ChevronLeftIcon } from 'ui-component/custom-icons/icons';
import { Skeleton, Tooltip } from '@mui/material';

const contactTypes = [
	{ label: 'Customer', value: 'customer' },
	{ label: 'Supplier', value: 'supplier' },
	{ label: 'Transit Company', value: 'transit-company' },
];
const hybridTypes = [
	{ label: 'Customer', value: 'customer' },
	{ label: 'Supplier', value: 'supplier' },
	{ label: 'Transit Company', value: 'transit-company' },
];

const transitCompanyTypes = [
	{ label: 'Child Company', value: 1 },
	{ label: 'External', value: 2 }
];

const ContactForm = ({ edit }) => {
	const { id } = useParams();
	const history = useNavigate();
	const nameRef = useRef();
	const vatNumberRef = useRef();
	const registrationNumberRef = useRef();
	const addressFieldRef = useRef();
	const shippingAddressRef = useRef();
	const emailRef = useRef();
	const contactPhoneRef = useRef();
	const [disableStatus, setDisablestatus] = useState(false);
	const [disableLogoStatus, setDisableLogoStatus] = useState(false);
	const [isTransitCompany, setIsTransitCompany] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [hasVatFile, setHasVatFile] = useState(false);
	const [showDeleteContactShippingDetailsPopup, setShowDeleteContactShippingDetailsPopup] = useState(false);	
	const [selectedContactShippingDetailsIndex, setSelectedContactShippingDetailsIndex] = useState(null);
	const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
	const [vatFile, setVatFile] = useState({
		id: '',
		contact_id: '',
		file_name: '',
		type: '',
		vat_attachment_url: ''
	});
	const [hasRegistrationFile, setHasRegistrationFile] = useState(false);
	const [registrationFile, setRegistrationFile] = useState({
		id: '',
		contact_id: '',
		file_name: '',
		type: '',
		registration_attachment_url: ''
	});

	const [hasCompanyLogo, setHasCompanyLogo] = useState(false);
	const [companyLogo, setCompanyLogo] = useState({
		id: '',
		contact_id: '',
		file_name: '',
		type: '',
		registration_attachment_url: ''
	});

	const saleManagerRef = useRef();
	const startYear = 1950;
	const currentYear = new Date().getFullYear();
	const years = [];
	const [companyactivity, setCompanyactivity] = useState([]);
	const [companyturnover, setCompanyturnover] = useState([]);
	const [alertMessage, setAlertmessage] = useState({});
	const [salesPerson, setSalesperson] = useState([]);
	const [companySpecifications, setCompanySpecifications] = useState([]);
	const [companyInterests, setCompanyInterests] = useState([]);
	const [vatValidationAlert, setVatvalidationlert] = useState('');
	const [contactInfo, setContactInfo] = useState({
		contactType: 'customer',
		name: '',
		establishment: '',
		companyactivity: '',
		turnover: '',
		vatNumber: '',
		registrationNumber: '',
		addressField: '',
		country: 'United Arab Emirates',
		state: '',
		city: '',
		zipCode: '',
		salesContact: '',
		emailIds: '',
		website: '',
		contactPhone: '',
		contactWhatsApp: '',
		salesManager: '',
		interests: [],
		specifications: [],
		status: 1,
		transitType: 2,
		vat_attachment_id: '',
		registration_attachment_id: '',
		logo_attachment_id: '',
		shippingAddress: '',
		shippingZipCode: '',
		shippingCity: '',
		shippingCountry: 'United Arab Emirates',
		transitFee: '',
		hybridType: '',
	});

	const [shippingContactsRow, setShippingContactsRow] = useState([]);
	const isValidEmail = (email) => {
		// Simple email regex
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	};
	const namehandle = (e) => {
		let inputValue = e.target.value;
		const words = inputValue.split(' ');
		const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.substr(1));
		inputValue = capitalizedWords.join(' ');
		e.target.value = inputValue;
	};
	const handleEmail = (e) => {
		const inputValue = e.target.value;
		const lowercaseValue = inputValue.toLowerCase();
		e.target.value = lowercaseValue;
	};
	const handleSalesContact = (e) => {
		const inputValue = e.target.value;
		const stringWithoutNumbers = inputValue.replace(/\d+/g, '');
		e.target.value = stringWithoutNumbers;
	};

	const [vatCheckTimer, setVatCheckTimer] = useState();

	const handlevatValidation = (e) => {
		let inputValue = e.target.value;
		setContactInfo({ ...contactInfo, vatNumber: inputValue });
		inputValue = inputValue.trim();
		const words = inputValue.split(' ');
		const capitalizedWords = words.map((word) => word.substr(0).toUpperCase());
		inputValue = capitalizedWords.join(' ');
		e.target.value = inputValue;

		if (vatCheckTimer) {
			clearTimeout(vatCheckTimer);
		}

		let timeout = setTimeout(() => {
			vatNumberValidation();
		}, 1000);

		setVatCheckTimer(timeout);
	};
	const handleRegistrationValidation = (e) => {
		let inputValue = e.target.value;
		const words = inputValue.split(' ');
		const capitalizedWords = words.map((word) => word.substr(0).toUpperCase());
		inputValue = capitalizedWords.join(' ');
		e.target.value = inputValue;
	};
	const handleChange = (val) => {
		setContactInfo(val);
	};
	
	const handleAddShippingContactsRow = () => {
		setShippingContactsRow((prevRows) => [
			...prevRows,
			{
				id: null,
				name: '',
				phone: '+31',
				email: '',
			}
		]);
	}
	const handleRemoveShippingContactsRow = (index) => {
		setShippingContactsRow((prevRows) => prevRows.filter((row, i) => i !== index));
	};
	const vatNumberValidation = () => {
		const vatNumbr = vatNumberRef.current.value;

		// UAE validation: 15 digits, starts with "100"
		if (contactInfo.country === 'United Arab Emirates') {
			const isValidUAE = /^\d{15}$/.test(vatNumbr) && vatNumbr.startsWith('100');
			if (!isValidUAE) {
				setVatvalidationlert(false);
				setAlertmessage({
					// vatNumber: 'UAE VAT must be 15 digits and start with "100".'
					vatNumber: 'Format is not valid.'
				});
				return
			} else {
				setVatvalidationlert(true);
			}
		} else {
			// Other countries: 9-12 chars, starts with 2 alphabets
			const isValidOther = /^[A-Za-z]{2}[A-Za-z0-9]{7,10}$/.test(vatNumbr);
			if (!isValidOther) {
				setVatvalidationlert(false);
				setAlertmessage({
					// vatNumber: 'VAT must be 9-12 characters and start with 2 alphabets.'
					vatNumber: 'Format is not valid.'
				});
				return
			} else {
				setVatvalidationlert(true);
			}
		}

		if (vatNumbr) {
			setAlertmessage({ vatNumber: '' });
		}
		handleChange({
			...contactInfo,
			vatNumber: vatNumbr,
		});
	};
	const vatNumberValidationByCountry = (valueCountry) => {
		const vatNumbr = vatNumberRef.current.value;
		const thisCountry = valueCountry;
		// UAE validation: 15 digits, starts with "100"
		if (thisCountry === 'United Arab Emirates') {
			const isValidUAE = /^\d{15}$/.test(vatNumbr) && vatNumbr.startsWith('100');
			if (!isValidUAE) {
				setVatvalidationlert(false);
				setAlertmessage({
					// vatNumber: 'UAE VAT must be 15 digits and start with "100".'
					vatNumber: 'Format is not valid.'
				});
				return
			} else {
				setVatvalidationlert(true);
			}
		} else {
			// Other countries: 9-12 chars, starts with 2 alphabets
			const isValidOther = /^[A-Za-z]{2}[A-Za-z0-9]{7,10}$/.test(vatNumbr);
			if (!isValidOther) {
				setVatvalidationlert(false);
				setAlertmessage({
					// vatNumber: 'VAT must be 9-12 characters and start with 2 alphabets.'
					vatNumber: 'Format is not valid.'
				});
				return
			} else {
				setVatvalidationlert(true);
			}
		}

		if (vatNumbr) {
			setAlertmessage({ vatNumber: '' });
		}
		handleChange({
			...contactInfo,
			vatNumber: vatNumbr,
			country: thisCountry
		});
	};


	const handleFileUpload = (e, attachmentType) => {
		const files = e.target.files;
		if (attachmentType == 'companylogo') {
			setDisableLogoStatus(true);
		}
		if (files && files.length > 0) {
			const formData = new FormData();
			for (let i = 0; i < files.length; i++) {
				formData.append('attachment_file', files[i]);
				formData.append('attachment_type', attachmentType);
			}
			if (id) {
				formData.append('contact_id', id);
			}
			api.addContactVatFile(formData).then((res) => {
				
				if (attachmentType == 'companylogo') {
					setDisableLogoStatus(false);
				}
				if (attachmentType == 'vat') {
					setContactInfo({ ...contactInfo, vat_attachment_id: res?.data?.attachment_id });
				}
				if (attachmentType == 'registration') {
					setContactInfo({ ...contactInfo, registration_attachment_id: res?.data?.attachment_id });
				}
				if (attachmentType == 'companylogo') {
					setContactInfo({ ...contactInfo, logo_attachment_id: res?.data?.attachment_id });
				}
			});
		}
	};

	const handleRemoveAttachment = (e, attachmentType) => {
		if (attachmentType == 'vat') {
			setHasVatFile(false);
		} else if (attachmentType == 'registration') {
			setHasRegistrationFile(false);
		} else if (attachmentType == 'companylogo') {
			setHasCompanyLogo(false);
		}
	};

	const handleSubmit = (e) => {
		if (edit && id) {
			e.preventDefault();
			let sameValue = false;
			if (contactInfo.name.trim() === '') {
				setAlertmessage({
					name: 'Company Name is required.'
				});
				nameRef.current.focus();
			} else if (contactInfo.salesManager.length === 0) {
				setAlertmessage({
					salesManager: 'Sales Manager is required.'
				});
			} else if (sameValue) {
				goback();
			} else {
				// Validate shipping contacts emails
				const invalidShippingEmail = shippingContactsRow.find(
					(row) => row.email && !isValidEmail(row.email)
				);
				if (invalidShippingEmail) {

					toast.error(`Invalid email format: ${invalidShippingEmail.email}`);
					return; // Stop submit
				}
				setIsSubmitDisabled(true);

				let contactPayloadExtra = {};

				// if (contactInfo?.contactType == 'lead' || contactInfo?.contactType == 'customer') {
				contactPayloadExtra = {
					...contactPayloadExtra,
					sales_manager_id: contactInfo?.salesManager || ''
				};
				// }

				if (contactInfo?.contactType == 'transit-company') {
					contactPayloadExtra = {
						...contactPayloadExtra,
						transit_type: contactInfo?.transitType || ''
					};
				}

				toast.promise(
					api
						.updateContact(id, {
							contact_type: contactInfo?.contactType,
							name: contactInfo.name,
							email: contactInfo.emailIds,
							vat_number: contactInfo.vatNumber,
							registration_number: contactInfo.registrationNumber,
							contact_name: contactInfo.salesContact,
							contact_phone: contactInfo.contactPhone,
							contact_whatsapp: contactInfo.contactWhatsApp || '',
							address: contactInfo?.addressField,
							country: contactInfo?.country || '',
							state: contactInfo?.state,
							city: contactInfo?.city || '',
							zipcode: contactInfo?.zipCode || '',
							establishment_year: contactInfo.establishment || '',
							company_activity_id: contactInfo?.companyactivity || '',
							turnover_id: contactInfo?.turnover || '',
							company_website: contactInfo?.website || '',
							status: contactInfo.status,
							is_vat_verified: vatValidationAlert == true ? true : false,
							interests: contactInfo?.interests,
							specifications: contactInfo?.specifications,
							shipping_address: contactInfo?.shippingAddress,
							shipping_zipcode: contactInfo?.shippingZipCode,
							shipping_city: contactInfo?.shippingCity,
							shipping_country: contactInfo?.shippingCountry,
							transit_fee: contactInfo?.transitFee,
							shipping_contacts: shippingContactsRow,
							hybrid_type: contactInfo?.hybridType || '',
							...contactPayloadExtra
						})
						.then(
							(res) => {
								if (res.status) {
									history('/contacts');
								} else {
									if (res.errors?.vat_number) {
										setAlertmessage({
											vatNumber: res.errors.vat_number
										});
										vatNumberRef.current.focus();
									} else if (res.errors?.registration_number) {
										setAlertmessage({
											registrationNumber: res.errors.registration_number
										});
										registrationNumberRef.current.focus();
									} else {
										setAlertmessage({
											failed: res.message
										});
									}
								}

								setIsSubmitDisabled(false);
								return res?.status ? res : null;
							},
							() => {
								setIsSubmitDisabled(false);
							}
						),
					{
						loading: 'Update Contact...',
						success: (data) => `${data.message}`,
						error: <b>Failed to update contact</b>
					}
				);
			}
		} else {
			e.preventDefault();
			if (contactInfo.name.trim() === '') {
				setAlertmessage({
					name: 'Company Name is required.'
				});
				nameRef.current.focus();
			} else if (contactInfo.salesManager.length === 0) {
				setAlertmessage({
					salesManager: 'Sales Manager is required.'
				});
				saleManagerRef.current.focus();
			} else {
				setIsSubmitDisabled(true);

				let contactPayloadExtra = {};

				contactPayloadExtra = {
					...contactPayloadExtra,
					sales_manager_id: contactInfo?.salesManager || ''
				};

				if (contactInfo?.contactType == 'transit-company') {
					contactPayloadExtra = {
						...contactPayloadExtra,
						transit_type: contactInfo?.transitType || ''
					};
				}

				toast.promise(
					api
						.addContact({
							contact_type: contactInfo?.contactType,
							name: contactInfo.name,
							email: contactInfo.emailIds,
							vat_number: contactInfo.vatNumber,
							registration_number: contactInfo.registrationNumber,
							contact_name: contactInfo.salesContact,
							contact_phone: contactInfo.contactPhone,
							contact_whatsapp: contactInfo.contactWhatsApp || '',
							address: contactInfo?.addressField,
							country: contactInfo?.country || '',
							state: contactInfo?.state,
							city: contactInfo?.city || '',
							zipcode: contactInfo?.zipCode || '',
							establishment_year: contactInfo.establishment || '',
							company_activity_id: contactInfo?.companyactivity || '',
							turnover_id: contactInfo?.turnover || '',
							company_website: contactInfo?.website || '',
							is_vat_verified: vatValidationAlert == true ? true : false,
							interests: contactInfo?.interests,
							specifications: contactInfo?.specifications,
							vat_attachment_id: contactInfo?.vat_attachment_id,
							registration_attachment_id: contactInfo?.registration_attachment_id,
							logo_attachment_id: contactInfo?.logo_attachment_id,
							shipping_address: contactInfo?.shippingAddress,
							shipping_zipcode: contactInfo?.shippingZipCode || '',
							shipping_city: contactInfo?.shippingCity || '',
							shipping_country: contactInfo?.shippingCountry || '',
							transit_fee: contactInfo?.transitFee || 0,
							shipping_contacts: shippingContactsRow,
							hybrid_type: contactInfo?.hybridType || '',
							...contactPayloadExtra
						})
						.then(
							(res) => {
								if (res.status) {
									history('/contacts');
								} else {
									if (res.errors?.vat_number) {
										setAlertmessage({
											vatNumber: res.errors?.vat_number
										});
										vatNumberRef.current.focus();
									} else if (res.errors?.registration_number) {
										setAlertmessage({
											registrationNumber: res.errors.registration_number
										});
										registrationNumberRef.current.focus();
									} else {
										setAlertmessage({
											failed: res.message
										});
									}
								}
								setIsSubmitDisabled(false);
								return res?.status ? res : null;
							},
							() => {
								setIsSubmitDisabled(false);
							}
						),
					{
						loading: 'Creating Contact...',
						success: (data) => `${data.message}`,
						error: <b>Failed to create contact</b>
					}
				);
			}
		}
	};
	const getAttributesList = () => {
		api.getSelectOptionsList('salesperson').then((res) => {
			const tempsalesPerson = res.data.map((item) => ({ id: item.id, name: `${item.first_name} ${item.last_name || ''}` }));
			setSalesperson(tempsalesPerson);
		});

		api.getSelectOptionsList('specification').then((res) => {
			const tempsalesPerson = res.data.map((item) => ({ id: item.id, name: item?.name }));
			setCompanySpecifications(tempsalesPerson);
		});

		api.getSelectOptionsList('interest').then((res) => {
			const tempsalesPerson = res.data.map((item) => ({ id: item.id, name: item?.name }));
			setCompanyInterests(tempsalesPerson);
		});

		api.allAttributes().then((res) => {
			let companyA = res.data.filter((item) => item.type == 'Company Activity').map((item) => ({ id: item.id, name: item.name }));
			let companyT = res.data.filter((item) => item.type == 'Company Turnover').map((item) => ({ id: item.id, name: item.name }));
			setCompanyactivity(companyA);
			setCompanyturnover(companyT);
		});

		if (edit) {
			getSelectedContact();
		}
	};

	useEffect(() => {
		getAttributesList();
		if (edit && id) {
		} else {
			setIsLoading(false)
			setLoading(false);
		}
	}, []);

	const getSelectedContact = () => {
		setLoading(true);
		api.getContactbyId(id).then((res) => {
			setLoading(false);
			if (!res.data) {
				setLoading(true);
				history('/contacts');
			} else {
				const loadData = res?.data;
				let tempdata = {
					contactType: loadData?.contact_type || '',
					name: loadData?.name || '',
					establishment: loadData?.establishment_year || '',
					companyactivity: loadData?.company_activity?.id || '',
					turnover: loadData?.company_turnover?.id || '',
					vatNumber: loadData?.vat_number || '',
					registrationNumber: loadData?.registration_number || '',
					addressField: loadData?.address?.address || '',
					country: loadData?.address?.country || '',
					state: loadData?.address?.state?.name || '',
					city: loadData?.address?.city || '',
					zipCode: loadData?.address?.zipcode || '',
					salesContact: loadData?.contact_name || '',
					emailIds: loadData?.email || '',
					website: loadData?.company_website || '',
					contactPhone: loadData?.contact_phone || '',
					contactWhatsApp: loadData?.contact_whatsapp || '',
					salesManager: loadData?.sales_manager_id || '',
					interests: loadData?.interests?.map((i) => i?.interest_id),
					specifications: loadData?.specifications?.map((i) => i?.specification_id),
					transitType: loadData?.transit_type || '',
					shippingAddress: loadData?.shipping?.address || '',
					shippingCountry: loadData?.shipping?.country || '',
					shippingCity: loadData?.shipping?.city || '',
					shippingZipCode: loadData?.shipping?.zipcode || '',
					transitFee: loadData?.transit_fee || '',
					hybridType: loadData?.hybrid_type || '',
				};
				if (loadData?.contact_type == 'transit-company') {
					setIsTransitCompany(true);
				} else {
					setIsTransitCompany(false);
				}
				setVatvalidationlert(loadData?.is_vat_verified ? true : false);
				setAlertmessage((oldData) => ({
					...oldData,
					vatNumber: loadData?.is_vat_verified ? true : 'VAT Not registered'
				}));
				setContactInfo(tempdata);
				setShippingContactsRow(loadData?.contact_shipping_details || []);
				loadData?.attachments?.map((i) => {
					if (i?.type == 'vat') {
						setVatFile({
							id: i?.id,
							contact_id: i?.contact_id,
							file_name: i?.file_name,
							type: i?.type,
							vat_attachment_url: i?.vat_attachment_url
						});
						setHasVatFile(true);
					}
					if (i?.type == 'registration') {
						setRegistrationFile({
							id: i?.id,
							contact_id: i?.contact_id,
							file_name: i?.file_name,
							type: i?.type,
							registration_attachment_url: i?.registration_attachment_url
						});
						setHasRegistrationFile(true);
					}
					if (i?.type == 'companylogo') {
						setCompanyLogo({
							id: i?.id,
							contact_id: i?.contact_id,
							file_name: i?.file_name,
							type: i?.type,
							registration_attachment_url: i?.company_logo_url
						});
						setHasCompanyLogo(true);
					}
				});
				setLoading(true);
				setIsLoading(false)
			}
		});
	};

	for (let year = currentYear; year >= startYear; year--) {
		years.push(year);
	}

	const goback = () => {
		history('/contacts');
	};

	const isMobile = useIsMobile();
	return (
		<>
			<div className="row m-0 create-contact-container">
				<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
					<div className="header-bubble" />
					<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
						<div
							style={{
								position: 'relative',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginBottom: 8,
								minHeight: 38 // ensures enough height for the button
							}}
						>
							{' '}
							<button
								type="button"
								aria-label="Back"
								onClick={() => history(-1)}
								className="circle-back-btn"
								style={{
									position: 'absolute',
									left: 20,
									top: '50%',
									transform: 'translateY(-50%)'
								}}
							>
								{/* Replace with your fi arrow icon, example below */}
								<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
									<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</button>
							<h5 className="m-0 p-0 pb-2" style={{ fontWeight: '500' }}>
								{edit ? 'Edit Contact' : 'Create Contact'}
							</h5>
						</div>
						<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
							{edit ? (
								<PermissionAllowed permissions={['Save Contact Details (Action)']}>
									<button type="submit" className="btn btn-primary btn-main" disabled={isSubmitDisabled || vatValidationAlert == 'loading'}>
										<FaSave /> Save Changes
									</button>
								</PermissionAllowed>
							) : (
								<PermissionAllowed permissions={['Create New Contact (Action)']}>
									<button
										type="submit"
										className={isSubmitDisabled ? `btn btn-main disabled` : `btn btn-main`}
										disabled={isSubmitDisabled}
										onClick={handleSubmit}
									>
										{isSubmitDisabled ? (
											<>
												<FaSpinner className="fa-spin" /> Creating Contact...
											</>
										) : (
											<>
												<FaPlus /> Create Contact
											</>
										)}
									</button>
								</PermissionAllowed>
							)}
						</div>
					</div>
				</div>
				<div>

					<div className="row">
						<div className="col-12">
							<div
								style={{
									display: 'flex',
									width: '100%',
									margin: '10px 0 -10px 0'
								}}
							>
								{
									id ? (
										!isMobile && (
											<button
												type="button"
												className="btn btn-primary btn-outlined-main white-var"
												style={{ minWidth: 'unset' }}
												onClick={() => {
													history(`/contacts/${id}`);
												}}
											>
												<ChevronLeftIcon /> Back to Preview
											</button>
										)
									) : (
										<button
											type="button"
											className="btn btn-primary btn-outlined-main white-var"
											style={{ minWidth: 'unset' }}
											onClick={() => {
												history(`/contacts`);
											}}
										>
											<ChevronLeftIcon /> Back to List
										</button>
									)
								}
							</div>
						</div>
					</div>
				<div
					className={`${isMobile ? 'mobile-scroll-container w-100 mobile-scroll-container-xsmaller' : 'card w-100 '}`}
					style={{ marginTop: isMobile ? '0px' : '', paddingBottom: isMobile ? '90px' : '15px', padding: '15px 20px 15px 20px' }}
				>
						
						<form action="" className="" onSubmit={handleSubmit}>
							<div className="section-head m-0 p-0 hide-on-mobile">
								<h5 className="m-0 p-0 pb-2" style={{ fontWeight: '500' }}>
									{edit ? 'Edit Contact' : 'Create Contact'}
								</h5>
							</div>
							<Scroller extraHeight={20}>
								<div className="form-section">
									<div className="form-section-head">
										<h4>General Information</h4>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Company Logo</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div className="rs-container">
														{hasCompanyLogo ? (
															<div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
																<a href={companyLogo?.registration_attachment_url} target="_blank">
																	<PrivacyModeContent>{companyLogo?.file_name}</PrivacyModeContent>
																</a>
																<Tooltip title="Replace Attachment" arrow placement="top">
																	<span
																		className="btnEdit plain-iconbtn"
																		style={{
																			height: '20px',
																			width: '20px',
																			fontSize: '10px',
																			display: 'inline-block',
																			marginLeft: '20px',
																			paddingLeft: '4px',
																			paddingTop: '1px'
																		}}
																		onClick={() => {
																			handleRemoveAttachment(companyLogo?.id, 'companylogo');
																		}}
																	>
																		<FaTimes />
																	</span>
																</Tooltip>
															</div>
														) : (
															''
														)}
														<div style={{ display: hasCompanyLogo ? 'none' : '' }}>
															<FileUpload
																className="form-control"
																accept=".png,.jpg,.jpeg,.pdf"
																loading={disableLogoStatus}
																onChange={(e) => {
																	handleFileUpload(e, 'companylogo');
																}}
															/>
														</div>
													</div>
												)
											}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Contact Type</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															menuPosition={'fixed'}
															options={contactTypes}
															value={contactTypes?.find((y) => y?.value == contactInfo?.contactType)}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																handleChange({
																	...contactInfo,
																	contactType: e.value,
																	hybridType: contactInfo?.hybridType === e.value ? '' : contactInfo?.hybridType // reset hybridType if contactType changes
																});
																if (e.value == 'transit-company') {
																	setIsTransitCompany(true);
																} else if (e?.value === 'customer') {
																	setIsTransitCompany(false);	
																} else {
																	setIsTransitCompany(false);
																}
																
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.contactType && (
												<span className="error-message text-danger">{alertMessage.contactType}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div
											className="form-group-body"
											style={{
												alignItems: 'center',
											}}
										>
											<div className="flex gap-2">

												<label htmlFor="">Hybrid Type</label>
												<div className="cursor-pointer tooltip-help-icon">

													<Tooltip title="Note: Enables a contact to function in multiple roles, including customer, transit company, or supplier." arrow placement="top">
														<div>
															<QuestionMarkCircleIcon width='15px' height='15px' />
														</div>
													</Tooltip>
												</div>
											</div>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
														<div>
														
															<Select
																menuPosition={'fixed'}
																options={hybridTypes.filter((y) => y.value !== contactInfo?.contactType)}
																value={contactInfo?.hybridType ? hybridTypes?.find((y) => y?.value == contactInfo?.hybridType) : null}
																className="rs-container"
																classNamePrefix="rs"
																placeholder="Select Hybrid Type"
																isClearable={true} 
																onChange={(e) => {
																	handleChange({ ...contactInfo, hybridType: e ? e.value : '' });
																
																}}
															/>
														</div>
													</div>
												)
											}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">
												Company <sup className="text-danger">*</sup>
											</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															ref={nameRef}
															type="text"
															className="form-control"
															id="inputName"
															maxLength={50}
															value={contactInfo?.name}
															onChange={(e) => {
																namehandle(e);
																handleChange({ ...contactInfo, name: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.name && (
												<span className="error-message text-danger">{alertMessage.name}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Establishment Year</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															options={years?.map((y) => ({ label: y, value: y }))}
															value={years?.map((y) => ({ label: y, value: y }))?.find((y) => y?.value == contactInfo?.establishment)}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																handleChange({ ...contactInfo, establishment: e.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.establishment && (
												<span className="error-message text-danger">{alertMessage.establishment}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Activity</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															options={companyactivity?.map((y) => ({ label: y.name, value: y.id }))}
															value={companyactivity
																?.map((y) => ({ label: y.name, value: y.id }))
																?.find((y) => y?.value == contactInfo?.companyactivity)}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																handleChange({ ...contactInfo, companyactivity: e.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.companyactivity && (
												<span className="error-message text-danger">{alertMessage.companyactivity}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Turnover</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															options={companyturnover?.map((y) => ({ label: y.name, value: y.id }))}
															value={companyturnover
																?.map((y) => ({ label: y.name, value: y.id }))
																?.find((y) => y?.value == contactInfo?.turnover)}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																handleChange({ ...contactInfo, turnover: e.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.turnover && (
												<span className="error-message text-danger">{alertMessage.turnover}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Interests</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															options={companyInterests?.map((y) => ({ label: y.name, value: y.id }))}
															value={companyInterests
																?.map((y) => ({ label: y.name, value: y.id }))
																?.filter((il) => (contactInfo?.interests?.find((item) => item == il?.value) ? true : false))}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																handleChange({ ...contactInfo, interests: e?.map((a) => a.value) });
															}}
															isMulti
															isClearable={false}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.turnover && (
												<span className="error-message text-danger">{alertMessage.turnover}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Specifications</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															options={companySpecifications?.map((y) => ({ label: y.name, value: y.id }))}
															value={companySpecifications
																?.map((y) => ({ label: y.name, value: y.id }))
																?.filter((il) => (contactInfo?.specifications?.find((item) => item == il?.value) ? true : false))}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																handleChange({ ...contactInfo, specifications: e?.map((a) => a.value) });
															}}
															isMulti
															isClearable={false}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.turnover && (
												<span className="error-message text-danger">{alertMessage.turnover}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">VAT Number</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<div className="vatCheck">
															<input
																ref={vatNumberRef}
																type="text"
																className="form-control"
																value={contactInfo?.vatNumber}
																id="inputName"
																onChange={(e) => {
																	handlevatValidation(e);
																}}
															/>
															{vatValidationAlert == true && (
																<span className="text-success">
																	<FaCircleCheck />
																</span>
															)}
															{vatValidationAlert == false && alertMessage?.vatNumber && (
																<span className="text-danger">
																	<FaTimesCircle />
																</span>
															)}
															{vatValidationAlert == 'loading' && (
																<span>
																	<ImSpinner2 className="fa-spin" />
																</span>
															)}
														</div>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.vatNumber && (
												<span className="error-message text-danger">{alertMessage.vatNumber}</span>
											)}
										</div>
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">VAT File</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div className="rs-container">
														{hasVatFile ? (
															<div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
																<a href={vatFile?.vat_attachment_url} target="_blank">
																	<PrivacyModeContent>{vatFile?.file_name}</PrivacyModeContent>
																</a>
																<Tooltip title="Replace Attachment" arrow placement="top">
																	<span
																		className="btnEdit plain-iconbtn"
																		style={{
																			height: '20px',
																			width: '20px',
																			fontSize: '10px',
																			display: 'inline-block',
																			marginLeft: '20px',
																			paddingLeft: '4px',
																			paddingTop: '1px'
																		}}
																		onClick={() => {
																			handleRemoveAttachment(vatFile?.id, 'vat');
																		}}
																	>
																		<FaTimes />
																	</span>
																</Tooltip>
															</div>
														) : (
															''
														)}

														<div style={{ display: hasVatFile ? 'none' : '' }}>
															<FileUpload
																className="form-control"
																accept=".png,.jpg,.jpeg,.pdf"
																loading={disableStatus}
																onChange={(e) => {
																	handleFileUpload(e, 'vat');
																}}
															/>
														</div>
													</div>
												)
											}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Registration number</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															ref={registrationNumberRef}
															type="text"
															value={contactInfo?.registrationNumber}
															className="form-control"
															id="inputName"
															onChange={(e) => {
																handleRegistrationValidation(e);
																handleChange({ ...contactInfo, registrationNumber: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.registrationNumber && (
												<span className="error-message text-danger">{alertMessage.registrationNumber}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Registration File</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (

													<div className="rs-container">
														{hasRegistrationFile ? (
															<div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
																<a href={registrationFile?.registration_attachment_url} target="_blank">
																	<PrivacyModeContent>{registrationFile?.file_name}</PrivacyModeContent>
																</a>
																<Tooltip title="Replace Attachment" arrow placement="top">
																	<span
																		className="btnEdit plain-iconbtn"
																		style={{
																			height: '20px',
																			width: '20px',
																			fontSize: '10px',
																			display: 'inline-block',
																			marginLeft: '20px',
																			paddingLeft: '4px',
																			paddingTop: '1px'
																		}}
																		onClick={() => {
																			handleRemoveAttachment(registrationFile?.id, 'registration');
																		}}
																	>
																		<FaTimes />
																	</span>
																</Tooltip>
															</div>
														) : (
															''
														)}
														<div style={{ display: hasRegistrationFile ? 'none' : '' }}>
															<FileUpload
																className="form-control"
																accept=".png,.jpg,.jpeg,.pdf"
																loading={disableStatus}
																onChange={(e) => {
																	handleFileUpload(e, 'registration');
																}}
															/>
														</div>
													</div>
												)
											}
										</div>
									</div>
								</div>
								{isTransitCompany && (
									<div className="form-section" style={{ marginTop: '20px' }}>
										<div className="form-section-head">
											<h4>Fees</h4>
										</div>
										<div className="form-group">
											<div className="form-group-body">
												<label htmlFor="">Transit Fee</label>
												{
													isLoading ? (
														<div style={{ width: '240px' }}>
															<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
														</div>
													) : (
														<div>
															<input
																value={contactInfo?.transitFee}
																type="text"
																className="form-control"
																id="inputName"
																onChange={(e) => {
																	handleChange({ ...contactInfo, transitFee: e.target.value });
																}}
															/>
														</div>
													)
												}
											</div>
											<div className="form-group-error">
												{alertMessage.shippingAddress && (
													<span className="error-message text-danger">{alertMessage.shippingAddress}</span>
												)}
											</div>
										</div>
									</div>
								)}

								<div className="form-section" style={{ marginTop: '20px' }}>
									<div className="form-section-head">
										<h4>Billing Address</h4>
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Address</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															ref={addressFieldRef}
															value={contactInfo?.addressField}
															type="text"
															className="form-control"
															id="inputName"
															onChange={(e) => {
																handleChange({ ...contactInfo, addressField: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.addressField && (
												<span className="error-message text-danger">{alertMessage.addressField}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Zip Code</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															type="text"
															className="form-control"
															id="inputName"
															value={contactInfo?.zipCode}
															maxLength={10}
															onChange={(e) => {
																handleChange({ ...contactInfo, zipCode: e?.target?.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.zipCode && (
												<span className="error-message text-danger">{alertMessage.zipCode}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">City</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															type="text"
															className="form-control"
															id="inputName"
															value={contactInfo?.city}
															onChange={(e) => {
																handleChange({ ...contactInfo, city: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.city && (
												<span className="error-message text-danger">{alertMessage.city}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Country</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															menuPosition={'fixed'}
															options={allCountriesList?.map((y) => ({ label: y.name, value: y.name }))}
															value={allCountriesList
																?.map((y) => ({ label: y.name, value: y.name }))
																?.find((y) => y?.value == contactInfo?.country)}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																setContactInfo({ ...contactInfo, country: e.value });
																vatNumberValidationByCountry(e.value);
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.country && (
												<span className="error-message text-danger">{alertMessage.country}</span>
											)}
										</div>
									</div>
								</div>

								<div className="form-section" style={{ marginTop: '20px' }}>
									<div className="form-section-head flex gap-3 align-items-center">
										<h4>Shipping Address</h4>

											{
												isLoading ? (
													<div style={{ width: '35px' }}>
														<Skeleton variant="rounded" width={'100%'} height={30}></Skeleton>
													</div>
												) : (
													<button
														type="button"
														className="btn btn-primary btn-main"
														onClick={() => {
															handleAddShippingContactsRow();
														}}
													>
														<FaPlus />
													</button>
												)
											}
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Address</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															ref={shippingAddressRef}
															value={contactInfo?.shippingAddress}
															type="text"
															className="form-control"
															id="inputName"
															onChange={(e) => {
																handleChange({ ...contactInfo, shippingAddress: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.shippingAddress && (
												<span className="error-message text-danger">{alertMessage.shippingAddress}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Zip Code</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															type="text"
															className="form-control"
															id="inputName"
															value={contactInfo?.shippingZipCode}
															maxLength={10}
															onChange={(e) => {
																handleChange({ ...contactInfo, shippingZipCode: e?.target?.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.shippingZipCode && (
												<span className="error-message text-danger">{alertMessage.shippingZipCode}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">City</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															type="text"
															className="form-control"
															id="inputName"
															value={contactInfo?.shippingCity}
															onChange={(e) => {
																handleChange({ ...contactInfo, shippingCity: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.shippingCity && (
												<span className="error-message text-danger">{alertMessage.shippingCity}</span>
											)}
										</div>
									</div>

									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Country</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															menuPosition={'fixed'}
															options={allCountriesList?.map((y) => ({ label: y.name, value: y.name }))}
															value={allCountriesList
																?.map((y) => ({ label: y.name, value: y.name }))
																?.find((y) => y?.value == contactInfo?.shippingCountry)}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																handleChange({ ...contactInfo, shippingCountry: e.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.shippingCountry && (
												<span className="error-message text-danger">{alertMessage.shippingCountry}</span>
											)}
										</div>
									</div>

									{shippingContactsRow?.length > 0 && (
										shippingContactsRow?.map((item, index) => (
											<div key={index}>
												<hr />

												<div className="form-group">
													<div className="form-group-body">
														<label htmlFor="">Contact </label>
														<div>
															<input
																type="text"
																className="form-control"
																id="inputName"
																value={item?.name}
																onChange={(e) => {
																	setShippingContactsRow(
																		shippingContactsRow.map((row, i) => (i === index ? { ...row, name: e.target.value } : row))
																	);
																}}
															/>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="form-group-body">
														<label htmlFor="">Phone Number</label>
														<div>
															<PhoneInput
																defaultCountry="NL"
																addInternationalOption={false}
																value={item?.phone}
																onChange={(phone) => {
																	setShippingContactsRow(
																		shippingContactsRow.map((row, i) => (i === index ? { ...row, phone: phone } : row))
																	);
																}}
															/>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="form-group-body">
														<label htmlFor="">Email Address</label>
														<div>
															<input
																type="email"
																className="form-control"
																id="inputName"
																value={item?.email}
																onChange={(e) => {
																	setShippingContactsRow(
																		shippingContactsRow.map((row, i) => (i === index ? { ...row, email: e.target.value } : row))
																	);
																}}
															/>
														</div>
													</div>
												</div>
												<div className="form-group">
													<div className="form-group-body">
														<label htmlFor=""></label>
														<div>
															<button
																type="button"
																className="btn btn-danger"
																onClick={() => {
																	if (item?.id) {
																		setShowDeleteContactShippingDetailsPopup(true);
																		setSelectedContactShippingDetailsIndex(index);
																	} else {
																		handleRemoveShippingContactsRow(index);
																	}
																}}
															>
																<CloseIcon height="8px" width="8px" /> Remove
															</button>
														</div>
													</div>
												</div>
											</div>
										))
									)}
								</div>

								<div className="form-section" style={{ marginTop: '20px' }}>
									<div className="form-section-head">
										<h4>Contact</h4>
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Sales Manager</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<Select
															menuPosition={'fixed'}
															ref={saleManagerRef}
															options={salesPerson?.map((y) => ({ label: y.name, value: y.id }))}
															value={salesPerson
																?.map((y) => ({ label: y.name, value: y.id }))
																?.find((y) => y?.value == contactInfo?.salesManager)}
															className="rs-container"
															classNamePrefix="rs"
															placeholder=""
															onChange={(e) => {
																handleChange({ ...contactInfo, salesManager: e.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.salesManager && (
												<span className="error-message text-danger">{alertMessage.salesManager}</span>
											)}
										</div>
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Sales Contact Name</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															type="text"
															className="form-control"
															id="inputName"
															value={contactInfo?.salesContact}
															maxLength={25}
															onChange={(e) => {
																handleSalesContact(e);
																namehandle(e);
																handleChange({ ...contactInfo, salesContact: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.salesContact && (
												<span className="error-message text-danger">{alertMessage.salesContact}</span>
											)}
										</div>
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Company Email</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															ref={emailRef}
															type="email"
															className="form-control"
															value={contactInfo?.emailIds}
															id="inputName"
															onChange={(e) => {
																handleEmail(e);
																handleChange({ ...contactInfo, emailIds: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.email && (
												<span className="error-message text-danger">{alertMessage.email}</span>
											)}
										</div>
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Website</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<input
															type="text"
															className="form-control"
															id="inputName"
															value={contactInfo?.website}
															onChange={(e) => {
																handleChange({ ...contactInfo, website: e.target.value });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error"></div>
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Phone Number</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<PhoneInput
															ref={contactPhoneRef}
															defaultCountry="NL"
															addInternationalOption={false}
															value={contactInfo?.contactPhone}
															onChange={(phone) => {
																handleChange({ ...contactInfo, contactPhone: phone });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage.contactPhone && (
												<span className="error-message text-danger">{alertMessage.contactPhone}</span>
											)}
										</div>
									</div>
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Whatsapp</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (
													<div>
														<PhoneInput
															ref={contactPhoneRef}
															defaultCountry="NL"
															addInternationalOption={false}
															value={contactInfo?.contactWhatsApp}
															onChange={(phone) => {
																handleChange({ ...contactInfo, contactWhatsApp: phone });
															}}
														/>
													</div>
												)
											}
										</div>
										<div className="form-group-error"></div>
									</div>

									{contactInfo?.contactType == 'transit-company' && (
										<div className="form-group">
											<div className="form-group-body">
												<label htmlFor="">Transit Company Type</label>
												{
													isLoading ? (
														<div style={{ width: '240px' }}>
															<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
														</div>
													) : (
														<div>
															<Select
																menuPosition={'fixed'}
																options={transitCompanyTypes}
																value={transitCompanyTypes?.find((y) => y?.value == contactInfo?.transitType)}
																className="rs-container"
																classNamePrefix="rs"
																placeholder=""
																onChange={(e) => {
																	handleChange({ ...contactInfo, transitType: e.value });
																}}
															/>
														</div>
													)
												}
											</div>
											<div className="form-group-error">
												{alertMessage.transitType && (
													<span className="error-message text-danger">{alertMessage.transitType}</span>
												)}
											</div>
										</div>
									)}
								</div>
							</Scroller>
							<div className="non-scroll-btn-section hide-on-mobile">
								<div className="btnarea pt-3 pt-md-0">
									{
										isLoading ? (
											<div style={{ width: '120px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										) : (
											edit ? (
												<PermissionAllowed permissions={['Save Contact Details (Action)']}>
													<button
														type="submit"
														className="btn btn-primary btn-main"
														disabled={isSubmitDisabled || vatValidationAlert == 'loading'}
													>
														<FaSave /> Save Changes
													</button>
												</PermissionAllowed>
											) : (
												<PermissionAllowed permissions={['Create New Contact (Action)']}>
													<button
														type="submit"
														className="btn btn-primary btn-main"
														disabled={isSubmitDisabled || vatValidationAlert == 'loading'}
													>
														<FaPlus /> Create
													</button>
												</PermissionAllowed>
											)
										)
									}
								</div>
							</div>
						</form>
				</div>
				</div>
			</div>

			{showDeleteContactShippingDetailsPopup && (
				<DeleteConfirmationGlass
					show={showDeleteContactShippingDetailsPopup}
					handleClose={() => {
						setShowDeleteContactShippingDetailsPopup(false);
						setSelectedContactShippingDetailsIndex(null);
						selectedContactShippingDetailsIndex;
					}}
					handleDelete={() => {
						handleRemoveShippingContactsRow(selectedContactShippingDetailsIndex);
						setShowDeleteContactShippingDetailsPopup(false);
						setSelectedContactShippingDetailsIndex(null);
					}}
					title="Confirm"
					message={`Are you sure you want to remove Shipping Address Contact?`}
				/>
			)}
		</>
	);
};

export default ContactForm;
